<template>
  <div>
    <!-- <div class="vld-parent"></div> -->
    <button v-if="$can('categories_create')" @click="createCategory" type="button" class="btn-basic mt-4 float-right">
      Add Category
    </button>
    <br /><br /><br /><br />
    <div class="card card-body p-0" style="border-radius: 10px">
      <div class="table-responsive">
        <table class="table table-hover border-bottom" id="dataTable" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th>Title</th>
              <th>Parent Category</th>
              <!-- <th>Moderator</th> -->
              <th>Posts</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <!-- link moderator -->
            <tr  v-if="displayLoader" id="table_row" >
              <td colspan="16">
                <b-skeleton-wrapper >
                    <b-skeleton height="40px" ></b-skeleton>   
                    <b-skeleton height="40px"></b-skeleton>  
                    <b-skeleton height="40px"></b-skeleton>                                     
                </b-skeleton-wrapper> 
              </td>
            </tr>
            <category-row v-show="!displayLoader" v-for="category in categories" :category="category" :key="category.id" :setSkeletonLoader="displayLoader"></category-row>
          </tbody>
        </table>

        <h5 style="text-align: center; margin-top: 2rem;" v-if="categories.length < 1  && !displayLoader">
          No data found.
        </h5>

        <paginate v-if="!displayLoader" v-model="page" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
          :first-button-text="''" :last-button-text="''" :first-last-button="true"
          :container-class="'pagination pagination-sm float-right mr-4 mb-0 mt-3'" :page-class="'page-item'"
          :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'"
          :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from "@/helpers.js";
  import categoryForm from "./form";
  import CategoryRow from "./category_row";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      CategoryRow,VueSkeletonLoader,
    },

    data: function () {
      return {
        page: 0,
        displayLoader: true,
        fullPage: "",
      };
    },

    computed: {
      categories: function () {
        return this.$store.getters["categories/categories"];
      },
      totalPages: function () {
        return this.$store.getters["categories/totalPages"];
      },
    },

    created: function () {
      this.page = helpers.getPageQuery();
    },

    watch: {
      page: function (val) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.setSkeletonLoader(true);
        this.$store.dispatch("categories/getAllCategories", val);
        setTimeout(() => {
          // loader.hide();
          this.setSkeletonLoader(false);
        }, 1500);
      },
    },

    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("categories?page=" + page);
      },

      createCategory() {
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "Add Category",
          component: categoryForm,
        });
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
      },
    },
  };
</script>

<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    margin: 0 auto;
    left: 40%;
    opacity: 0.5 !important;
  }

  .abc {
    border: none !important;
  }

  .page-link {
    border: none !important;
  }
</style>

